class WLSBuybox extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
  
      this.onFrequencyChange = this.onFrequencyChange.bind(this);
      this.onOptionClick = this.onOptionClick.bind(this);
      this.onQtyChange = this.onQtyChange.bind(this);
      this.onProductOptionChange = this.onProductOptionChange.bind(this);
    }
  
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      requestAnimationFrame(() => this.init());
    }
  
    init() {
      this.hasComparePrice = this.dataset.hasComparePrice === 'true';
      this.atcComparePriceEl = this.querySelector('.js-atc-compare-price') || null;

      this.basePriceCents = parseInt(this.dataset.basePriceCents, 10) || 0;
  
      this.form = this.querySelector('form[action*="/cart/add"]') || this.querySelector('form');
      this.sellingPlanInput = this.form?.querySelector('input[name="selling_plan"]') || null;
  
      this.subDiscountEl = this.querySelector('.js-sub-discount');
      this.subPriceEl = this.querySelector('.js-sub-price');
      this.comparePriceEl = this.querySelector('.js-compare-price');
  
      this.atcPriceEl = this.querySelector('.js-atc-price');
      this.atcQtyInput = this.form?.querySelector('input[name="quantity"]') || this.querySelector('input[name="quantity"]');
  
      this.frequencySelect = this.querySelector('#frequency');
  
      this.mode = 'subscribe';
      this.currentDiscount = 0;
      this.currentUnitPriceCents = this.basePriceCents;

      this.sectionHandle = this.dataset.sectionHandle || 'wls-buy-box';
      this.productHandle = this.dataset.productHandle || '';
      this.productJson = null;
  
      this.initSlidersWithRetry();
      this.initPurchaseOptions();
      this.initFrequency();
      this.initQuantity();
      this.initAccordion();
      this.initProductOptions();
      this.initNiceSelects();
  
      this.syncFromFrequencySelect();
      this.syncAtcTotal();

      if (!this.querySelector('.js-manual-upsell')) {
        this.fetchRecommendations();
      }
    }

    initNiceSelects() {
      if (!window.NiceSelect) return;
    
      const url = new URL(window.location.href);
      const hasOptionValues = url.searchParams.has('option_values');
    
      const selects = Array.from(this.querySelectorAll('.wls-buy-box__product-option-select'));
    
      selects.forEach(sel => {
        if (sel.nextSibling?.classList?.contains('nice-select')) {
          NiceSelect.destroy(sel);
        }
    
        if (!hasOptionValues && (sel.selectedIndex < 0 || !sel.value)) {
          sel.selectedIndex = 0;
        }
    
        NiceSelect.bind(sel);
      });
    }
    

    initProductOptions() {
      this.optionSelects = Array.from(this.querySelectorAll('.wls-buy-box__right select[name]'))
        .filter(sel => sel.id !== 'frequency'); // da ne kacimo selling plan select
    
      if (!this.optionSelects.length) return;
    
      // 1) Apply from URL on first load (option_values=Val1|Val2)
      const url = new URL(window.location.href);
      const optionValuesParam = url.searchParams.get('option_values');
      if (optionValuesParam) {
        const parts = optionValuesParam.split('|').map(v => decodeURIComponent(v));
        // match by order product.options_with_values
        this.optionSelects.forEach((sel, idx) => {
          if (parts[idx] && Array.from(sel.options).some(o => o.value === parts[idx])) {
            sel.value = parts[idx];
          }
        });
      }
    
      // 2) Listen changes
      this.optionSelects.forEach(sel => sel.addEventListener('change', this.onProductOptionChange));
    }
    
    async onProductOptionChange() {
      // Build option_values string in correct order
      const values = this.optionSelects.map(sel => sel.value);
      const optionValues = values.map(v => encodeURIComponent(v)).join('|');
    
      // Resolve variant id from product json (so Liquid renders correct prices / plans)
      const variantId = await this.getVariantIdFromSelectedOptions(values);
    
      // Update URL (no reload)
      const url = new URL(window.location.href);
      url.searchParams.set('option_values', values.join('|')); // human readable
      if (variantId) url.searchParams.set('variant', String(variantId));
      history.replaceState({}, '', url.toString());
    
      // Refresh section (swap whole buybox)
      await this.refreshBuyboxSection({ option_values: values.join('|'), variant: variantId });
    }
    
    async getVariantIdFromSelectedOptions(values) {
      if (!this.productHandle) return null;
    
      if (!this.productJson) {
        try {
          const res = await fetch(`/products/${this.productHandle}.js`, { credentials: 'same-origin' });
          if (!res.ok) return null;
          this.productJson = await res.json();
        } catch (e) {
          return null;
        }
      }
    
      const variants = this.productJson?.variants || [];
      const match = variants.find(v => {
        // Shopify .js gives option1/2/3
        const opts = [v.option1, v.option2, v.option3].filter(Boolean);
        // compare only the amount of selects we have
        for (let i = 0; i < values.length; i++) {
          if ((opts[i] || '') !== values[i]) return false;
        }
        return true;
      });
    
      return match?.id || null;
    }
    
    async refreshBuyboxSection(params = {}) {
      const sectionId = this.sectionHandle || 'wls-buy-box';
      const handle = this.productHandle;
    
      if (!handle) return;
    
      const url = new URL(`/products/${handle}`, window.location.origin);
      url.searchParams.set('section_id', sectionId);
    
      if (params.variant) url.searchParams.set('variant', String(params.variant));
      if (params.option_values) url.searchParams.set('option_values', params.option_values);
    
      const html = await fetch(url.toString(), { credentials: 'same-origin' })
        .then(r => r.text())
        .catch(() => '');
    
      if (!html) return;
    
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('wls-buybox');
      if (!fresh) return;
    
      this.replaceWith(fresh);
    }
    
    

    updateAtcCompareVisibility() {
        if (!this.atcComparePriceEl) return;
      
        if (this.mode === 'subscribe') {
          this.atcComparePriceEl.style.display = '';
          return;
        }
      
        if (this.hasComparePrice) {
          this.atcComparePriceEl.style.display = '';
          return;
        }
      
        this.atcComparePriceEl.style.display = 'none';
    }

  
    initSliders() {
      const thumbsEl = this.querySelector('#wls-thumbs-slider');
      const mainEl = this.querySelector('#wls-main-slider');
      const smallEl = this.querySelector('#wls-small-slider');
  
      if (thumbsEl && mainEl && window.Splide) {
        this.thumbs = new Splide(thumbsEl, {
          type: 'slide',
          perPage: 4,
          gap: 16,
          pagination: false,
          isNavigation: true,
          arrows: true,
        });
  
        this.main = new Splide(mainEl, {
          type: 'loop',
          gap: 12,
          pagination: false,
          arrows: false,
          breakpoints: { 500: { pagination: true, focus: 'center' } },
        });
  
        this.main.sync(this.thumbs);
        this.main.mount();
        this.thumbs.mount();
      }

    }

    initSlidersWithRetry(tries = 10) {
      if (window.Splide) {
        this.initSliders();
        return;
      }
      if (tries <= 0) return;
      setTimeout(() => this.initSlidersWithRetry(tries - 1), 100);
    }

    initSmallSlider() {
        const smallEl = this.querySelector('#wls-small-slider');
        if (smallEl && window.Splide) {
            this.sliderLike = new Splide(smallEl, {
              type: 'slide',
              perPage: 1,
              gap: 16,
              arrows: true,
              pagination: false,
            });
      
            this.sliderLike.mount();
      
            const arrows = smallEl.querySelector('.splide__arrows');
            const headerArrows = this.querySelector('.wls-buy-box__small-slider-arrows');
            if (arrows && headerArrows) headerArrows.appendChild(arrows);
          }
    }
  
    initPurchaseOptions() {
      this.options = Array.from(this.querySelectorAll('.wls-buy-box__option'));
      this.options.forEach(option => option.addEventListener('click', this.onOptionClick));
    }
  
    onOptionClick(e) {
      const option = e.currentTarget;
      if (e.target.closest('.wls-buy-box__frequency')) return;
  
      this.options.forEach(o => {
        o.classList.remove('is-active');
        const r = o.querySelector('input[type="radio"]');
        if (r) r.checked = false;
      });
  
      option.classList.add('is-active');
      const radio = option.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;
  
      if (option.dataset.option === 'subscribe') {
        this.mode = 'subscribe';
        this.syncFromFrequencySelect();
      } else {
        this.mode = 'onetime';
        if (this.sellingPlanInput) this.sellingPlanInput.value = '';
        this.syncOneTimePrices();
        this.syncAtcTotal();
      }
      this.updateAtcCompareVisibility();
    }
  
    initFrequency() {
      if (!this.frequencySelect) return;
  
      this.frequencySelect.addEventListener('change', this.onFrequencyChange);
  
      if (window.NiceSelect) {
        if (this.frequencySelect.nextSibling?.classList?.contains('nice-select')) {
          NiceSelect.destroy(this.frequencySelect);
        }
        NiceSelect.bind(this.frequencySelect);
      }
    }
  
    onFrequencyChange() {
      //if (!this.isSubscribeActive()) return;
      this.syncFromFrequencySelect();
      if (this.isSubscribeActive()) {
        this.syncAtcTotal();
      }
    }
  
    syncFromFrequencySelect() {
      //f (!this.isSubscribeActive()) return;
      const select = this.frequencySelect;
      if (!select) return;
  
      const selected = select.options[select.selectedIndex];
      const planId = selected?.value || '';
      const discount = parseFloat(selected?.dataset?.discount || '0') || 0;
  
      this.currentDiscount = discount;
  
      if (this.sellingPlanInput) this.sellingPlanInput.value = planId;
      if (this.subDiscountEl) this.subDiscountEl.textContent = String(discount);
  
      const discountedCents = Math.round(this.basePriceCents * (discount / 100));
      const newPriceCents = Math.max(0, this.basePriceCents - discountedCents);
  
      this.currentUnitPriceCents = newPriceCents;
  
      if (this.comparePriceEl) this.comparePriceEl.textContent = this.formatMoney(this.basePriceCents);
      if (this.subPriceEl) this.subPriceEl.textContent = this.formatMoney(newPriceCents);
  
      if (this.isSubscribeActive()) {
        this.syncAtcTotal();
      }
    }
  
    syncOneTimePrices() {
      this.currentDiscount = 0;
      this.currentUnitPriceCents = this.basePriceCents;
  
      if (this.comparePriceEl) this.comparePriceEl.textContent = this.formatMoney(this.basePriceCents);
      
    }
  
    initQuantity() {
      const qtyWrapper = this.querySelector('.wls-buy-box__qty');
      if (!qtyWrapper) return;
  
      const input = qtyWrapper.querySelector('input');
      const minus = qtyWrapper.querySelector('button:first-child');
      const plus = qtyWrapper.querySelector('button:last-child');
  
      if (!input || !minus || !plus) return;
  
      input.addEventListener('change', this.onQtyChange);
      input.addEventListener('input', this.onQtyChange);
  
      minus.addEventListener('click', () => {
        const value = parseInt(input.value, 10) || 1;
        if (value > 1) input.value = value - 1;
        this.syncAtcTotal();
      });
  
      plus.addEventListener('click', () => {
        const value = parseInt(input.value, 10) || 1;
        input.value = value + 1;
        this.syncAtcTotal();
      });
    }
  
    onQtyChange() {
      this.syncAtcTotal();
    }
  
    syncAtcTotal() {
      const qty = Math.max(1, parseInt(this.atcQtyInput?.value, 10) || 1);
      const totalCents = this.currentUnitPriceCents * qty;
      if (this.atcPriceEl) this.atcPriceEl.textContent = this.formatMoney(totalCents);
      if (this.atcComparePriceEl) this.atcComparePriceEl.textContent = this.formatMoney(this.basePriceCents * qty);
    }
  
    formatMoney(cents) {
      const format = (window.Shopify && Shopify.money_format) ? Shopify.money_format : '${{amount}}';
      return this.shopifyFormatMoney(cents, format);
    }
  
    shopifyFormatMoney(cents, format) {
      let value = cents;
  
      if (typeof value === 'string') value = value.replace('.', '');
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  
      const formatWithDelimiters = (number, precision = 2, thousands = ',', decimal = '.') => {
        if (isNaN(number) || number == null) return '0';
        const fixed = (number / 100).toFixed(precision);
        const parts = fixed.split('.');
        parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
        return parts.join(decimal);
      };
  
      const match = format.match(placeholderRegex);
      if (!match) return String((value / 100).toFixed(2));
  
      switch (match[1]) {
        case 'amount':
          return format.replace(placeholderRegex, formatWithDelimiters(value, 2, ',', '.'));
        case 'amount_no_decimals':
          return format.replace(placeholderRegex, formatWithDelimiters(value, 0, ',', '.'));
        case 'amount_with_comma_separator':
          return format.replace(placeholderRegex, formatWithDelimiters(value, 2, '.', ','));
        case 'amount_no_decimals_with_comma_separator':
          return format.replace(placeholderRegex, formatWithDelimiters(value, 0, '.', ','));
        default:
          return format.replace(placeholderRegex, formatWithDelimiters(value, 2, ',', '.'));
      }
    }
  
    initAccordion() {
      const items = this.querySelectorAll('.wls-buy-box__accordion-item');
      items.forEach(item => {
        const header = item.querySelector('.wls-buy-box__accordion-item-header');
        if (!header) return;
  
        header.addEventListener('click', () => {
          items.forEach(i => { if (i !== item) i.classList.remove('active'); });
          item.classList.toggle('active');
        });
      });
    }

    isSubscribeActive() {
        return this.querySelector('.wls-buy-box__option[data-option="subscribe"]')?.classList.contains('is-active');
    }
    
    fetchRecommendations() {
        const productId = this.dataset.productId;
        const container = this.querySelector('.js-buybox-upsell');
        fetch(`/recommendations/products?section_id=wls-pdp-upsell&product_id=${productId}`)
        .then(res => res.text())
        .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            const section = doc.querySelector('#shopify-section-wls-pdp-upsell');

            if (container && section) {
            container.innerHTML = section.innerHTML;
            }

            this.initSmallSlider();
        });
    }
  }
  
  if (!customElements.get('wls-buybox')) {
    customElements.define('wls-buybox', WLSBuybox);
  }